import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import {
  useUpdateTicketStatusMutation,
} from 'api/tickets'
import { RouteTicketingSystemsTicket } from 'routes'

import SidebarSection from 'components/Shared/Sidebar/SidebarSection/Index'
import SidebarText from 'components/Shared/Sidebar/SidebarText/Index'
import InlineSelect from 'components/Shared/InlineSelect/Index'
import ColorCircle from 'components/Shared/ColorCircle/Index'

const SidebarStatusSection = ({ ticket }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [updateStatus] = useUpdateTicketStatusMutation()

  const onStatusChange = (value) => {
    const ticketingSystemDisplayId = ticket.ticketingSystemDisplayId
    const ticketId = ticket.externalId

    updateStatus({
      ticketingSystemDisplayId: ticketingSystemDisplayId,
      ticketId: ticketId,
      status: value,
    }).then(fulfilled => {
      if (!fulfilled.data?.error) {
        navigate(RouteTicketingSystemsTicket({ ticketingSystemDisplayId, ticketId }))
      }
    })
  }

  const getStatusOptions = (status, isEditable) => {
    const statusOptions = [{
      label: status,
      value: status,
    }]
    if (isEditable) {
      ticket.availableStatusesList.forEach(v => {
        statusOptions.push({
          label: v,
          value: v,
        })
      })
    }
    return statusOptions
  }

  const status = ticket?.partnerStatus

  // no data
  if (!status) {
    return (
      <SidebarSection title={t('sidebar.statusSection')}>
        <SidebarText />
      </SidebarSection>
    )
  }

  const isEditable = !ticket.availableStatusesList.length ? false : ticket.canUpdateStatus
  const statusOptions = getStatusOptions(status, isEditable)

  const iconComponentsMap = {}
  statusOptions.forEach(statusOption => {
    const color = ticket.partnerStatusColors.find(v => v.name === statusOption.value).color
    iconComponentsMap[statusOption.value] = <ColorCircle color={color} />
  })

  return (
    <SidebarSection title={t('sidebar.statusSection')} copyText={status}>
      <InlineSelect
        disabled={!isEditable}
        value={status}
        onChange={onStatusChange}
        options={statusOptions}
        iconComponentsMap={iconComponentsMap}
      />
    </SidebarSection>
  )
}

SidebarStatusSection.propTypes = {
  ticket: PropTypes.object,
}

export default SidebarStatusSection
